import React, { useState, useEffect, useCallback } from "react"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import { makeStyles, ThemeProvider } from "@material-ui/core/styles"
import { Divider } from "@material-ui/core"
import DialogContent from "@material-ui/core/DialogContent"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import DialogTitle from "@material-ui/core/DialogTitle"
import FormControl from "@material-ui/core/FormControl"
import FormHelperText from "@material-ui/core/FormHelperText"
import { useDispatch } from "react-redux"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import { createFeedback, updateFeedback } from "./store/FeedbackService"
import CustomInput from "../../../../../../Components/CustomInput"
import { commonTheme } from "../../../../../../commonTheme"

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "500px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "inherit",
    fontSize: "16px",
    fontFamily: "Open Sans",
  },
  dialog_title: {
    marginLeft: "1.5rem",
    "& h6": {
      fontSize: "24px",
      fontFamily: "Lato",
      fontWeight: 700,
    },
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "94%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    font: "Open Sans",
    display: "block",
    outline: "none",

    "&:focus": {
      border: "2px solid #3B86FF",
    },
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    "& span:last-child": {
      fontSize: "13px",
      color: "#303030",
    },
    "& svg": {
      width: "1.2em",
      height: "1.2em",
    },
  },
  inputLabel: {
    top: "50%",
    left: "10px",
    transform: "translate(0, -50%)",
  },
  inputLabelField: {
    color: "#a9a9a9 !important",
    fontSize: "1rem",
    textTransform: "inherit",
  },
}))

interface IProps {
  isOpen: any
  onClose(): void
  props: any
  pageData: any
  onCreate: any
  currentSelection: any
  orgData: any
}

const FeedbackModal: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { isOpen, onClose, currentSelection, orgData } = props
  const [submitClickFlag, setSubmitClickFlag] = useState<boolean>(false)
  const [fromData, setFromData] = useState<any>(undefined)

  console.log("fromData", fromData)

  const handleChangeTextArea = (value: string, key: string) => {
    setFromData({ ...fromData, [key]: value })
  }

  const handleSubmit = useCallback(
    (e: any) => {
      e.preventDefault()
      setSubmitClickFlag(true)
      let isError = false
      if (fromData && !fromData?.organisation_id) {
        isError = true
      } else if (fromData && !fromData?.feedback) {
        isError = true
      } else if (fromData && !fromData?.given_by) {
        isError = true
      }
      if (!isError) {
        var formData: any = new FormData()
        formData.append("feedback", fromData?.feedback)
        formData.append("organisation_id", fromData?.organisation_id)
        formData.append("given_by", fromData?.given_by)
        if (!currentSelection?.id) {
          dispatch(
            createFeedback(formData, (): any => {
              onClose()
              props.onCreate()
            })
          )
        } else {
          formData.append("feedback_id", currentSelection?.id)
          dispatch(
            updateFeedback(formData, (): any => {
              onClose()
              props.onCreate()
            })
          )
        }
      }
    },
    [currentSelection?.id, dispatch, fromData, onClose, props]
  )

  useEffect(() => {
    if (currentSelection) {
      const { organisation_id, given_by, feedback } = currentSelection
      setFromData({
        ...fromData,
        organisation_id,
        given_by,
        feedback,
      })
    }
  }, [currentSelection])

  return (
    <ThemeProvider theme={commonTheme}>
      <Dialog
        maxWidth={"sm"}
        fullWidth={true}
        open={isOpen}
        onClose={() => onClose()}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          id="customized-dialog-title"
          // className={classes.dialog_title}
        >
          {" "}
          <Typography variant="h1" style={{ fontWeight: 700 }}>
            {currentSelection?.id ? "Edit" : "Add"} Feedback{" "}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: "0px auto" }}>
          <div className={classes.formWrapper}>
            <form spellCheck="false" onSubmit={handleSubmit}>
              <div>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3}>
                    <Typography variant="subtitle2" className={classes.title}>
                      Organization
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid xs={12}>
                      <FormControl
                        size="small"
                        style={{ width: "100%" }}
                        variant="outlined"
                      >
                        {!Boolean(fromData?.organisation_id) && (
                          <InputLabel
                            className={classes.inputLabelField}
                            shrink={false}
                            id="service_type"
                          >
                            Select organization
                          </InputLabel>
                        )}
                        <Select
                          error={
                            submitClickFlag && !fromData?.organisation_id
                              ? true
                              : false
                          }
                          labelId="organization"
                          autoFocus
                          id="organization"
                          name="organization"
                          placeholder={"Select Organization"}
                          onChange={(e: any) =>
                            handleChangeTextArea(
                              (e.target.value as string) || "",
                              "organisation_id"
                            )
                          }
                          value={fromData?.organisation_id || ""}
                        >
                          {orgData?.length &&
                            orgData?.map((data: any, index: number) => {
                              return (
                                <MenuItem key={index} value={data?.id}>
                                  {data?.organisation_name}
                                </MenuItem>
                              )
                            })}
                        </Select>
                        <FormHelperText
                          style={{ marginLeft: "2px" }}
                          error={
                            submitClickFlag && !fromData?.organisation_id
                              ? true
                              : false
                          }
                        >
                          {submitClickFlag && !fromData?.organisation_id
                            ? "Organisation is requied."
                            : null}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3} alignItems={"flex-start"}>
                    <Typography variant="subtitle2" className={classes.title}>
                      Given by
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <CustomInput
                        error={
                          submitClickFlag && !fromData?.given_by ? true : false
                        }
                        variant="outlined"
                        name={`given_by`}
                        value={fromData?.given_by}
                        placeholder="Given by"
                        parentcall={(value: any, name: string) => {
                          handleChangeTextArea(value, "given_by")
                        }}
                        size="small"
                        InputLabelProps={{ shrink: false }}
                      />
                      {submitClickFlag && !fromData?.given_by ? (
                        <FormHelperText
                          style={{ color: "red", marginLeft: "2px" }}
                        >
                          Given by is requied.
                        </FormHelperText>
                      ) : (
                        <></>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3} alignItems={"flex-start"}>
                    <Typography variant="subtitle2" className={classes.title}>
                      Feedback
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <CustomInput
                        error={
                          submitClickFlag && !fromData?.feedback ? true : false
                        }
                        variant="outlined"
                        name={`feedback`}
                        multiline
                        rows={6}
                        value={fromData?.feedback}
                        placeholder="Feedback"
                        parentcall={(value: any, name: string) => {
                          handleChangeTextArea(value, "feedback")
                        }}
                        size="small"
                        InputLabelProps={{ shrink: false }}
                      />
                      {submitClickFlag && !fromData?.feedback ? (
                        <FormHelperText
                          style={{ color: "red", marginLeft: "2px" }}
                        >
                          Feedback is requied.
                        </FormHelperText>
                      ) : (
                        <></>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-end"}
                  style={{ marginTop: 20 }}
                >
                  <Grid
                    item
                    xs={2}
                    style={{
                      marginRight: "1rem",
                      // fontSize: "14px",
                      // fontFamily: "Open Sans",
                      // lineHeight: "16px",
                      height: "35px",
                    }}
                  >
                    <Button
                      disableElevation
                      type="button"
                      style={{ textTransform: "capitalize" }}
                      onClick={() => {
                        onClose()
                      }}
                      variant={"contained"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      disableElevation
                      type="submit"
                      style={{
                        textTransform: "capitalize",
                        marginTop: "4px",
                        marginLeft: "-13px",
                      }}
                      variant={"contained"}
                      color="secondary"
                    >
                      {currentSelection?.id ? "Edit" : "Add"}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  )
}

export default FeedbackModal
